import { Stack, Typography } from '@mui/material';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { NoDataFound2 } from 'Components/NoDataFound2';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { HeaderTabs } from '../HeaderTabs';
import { PaychecksAlert } from '../PaychecksAlert';

interface INoPaychecksFound {
  tabValue: number;
  handleTabChange: (
    event: React.ChangeEvent<{}>,
    newValue: React.SetStateAction<number>
  ) => void;
}
export const NoPaychecksFound = ({
  tabValue,
  handleTabChange,
}: INoPaychecksFound) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Paychecks);
  const redirects = [
    {
      text: dictionary.noDataOffer1,
      href: `${process.env.REACT_APP_REDIRECT_URL}universalRequest/${
        tabValue === 0 ? '1/5/2' : '1/5/24'
      }`,
    },
    {
      text: dictionary.noDataOffer2,
      href: `${process.env.REACT_APP_REDIRECT_URL}personal-team`,
    },
    {
      text: dictionary.noDataOffer3,
      href: `${process.env.REACT_APP_REDIRECT_URL}payments&deductions`,
    },
  ];

  return (
    <Stack height={isDesktop ? '1100px' : '830px'}>
      <CustomMetaTitle title={dictionary.title} />
      <LinkReturnToMain />
      <Stack alignItems={isDesktop ? 'center' : 'flex-start'}>
        <Stack gap={'40px'} maxWidth='920px' top={isDesktop ? '76px' : '44px'}>
          <Stack
            alignItems={isDesktop ? 'center' : 'flex-start'}
            gap={isDesktop ? '16px' : '8px'}
            padding={'20px'}
          >
            <Typography variant='h2' color={'text.secondary'}>
              {dictionary.title}
            </Typography>
            <Typography variant='body3' color={'text.secondary'}>
              {dictionary.subtitle.lineOne}
            </Typography>
            <Stack marginY={isDesktop ? '16px' : '8px'}>
              <PaychecksAlert />
            </Stack>
          </Stack>
          <HeaderTabs handleTabChange={handleTabChange} tabValue={tabValue} />
          <NoDataFound2
            gap={isDesktop ? '48px' : '32px'}
            redirects={redirects}
            headerComponent={
              <Stack alignItems={'center'} gap={'4px'}>
                <Typography variant='h3' color='text.secondary'>
                  {tabValue === 0
                    ? dictionary.noDataPayslipsTitle
                    : dictionary.noDataTofes106Title}
                </Typography>
                <Typography variant={'body3'} color='text.secondary'>
                  {tabValue === 0
                    ? dictionary.noDataPayslipsSubtitle
                    : dictionary.noDataTofes106Subtitle}
                </Typography>
              </Stack>
            }
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
